import React, { useEffect } from "react";
import { InputGroup, Dialog, Classes, Button, Intent } from "@blueprintjs/core";

const DialoguAddChainedSession = ({
  chainedSession,
  dialogIsOpen,
  submitting,
  onCloseDialog,
  onChangeInput,
  onAddChainedSession,
}) => {
  /// Si la touche Entrée est pressée, la fonction onAddChainedSession est appelée.
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.keyCode === 13) {
        onAddChainedSession();
      }
    };

    // Attach the event listener
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onAddChainedSession]);

  return (
    <Dialog
      icon="link"
      title="Add a link to another session"
      autoFocus={true}
      canEscapeKeyClose={true}
      canOutsideClickClose={true}
      usePortal={true}
      enforceFocus={true}
      isOpen={dialogIsOpen}
      onClose={onCloseDialog}
    >
      <div className={Classes.DIALOG_BODY}>
        <InputGroup
          id="linked-session-name"
          onChange={onChangeInput}
          value={chainedSession}
          placeholder="Enter the session's link..."
        />
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={onCloseDialog} text="Cancel" disabled={submitting} />
          <Button
            onClick={onAddChainedSession}
            text="Add"
            intent={Intent.SUCCESS}
            rightIcon="add"
            loading={submitting}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default DialoguAddChainedSession;
